import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: null, // No default role
  user: null, // No default user
  token: null, // No default token
};

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setAuth: (state, action) => {
      // Set both user and token
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.role = action.payload.user?.role || null;
    },
    clearAuth: state => {
      state.user = null;
      state.token = null;
      state.role = null;
    },
    clearRole: state => {
      state.role = null;
      state.user = null;
      state.token = null;
    },
    logout: state => {
      state.role = null;
      state.user = null;
      state.token = null;
    },
    // Add action to switch between dummy roles for testing
    switchToRole: (state, action) => {
      const newRole = action.payload;
      state.role = newRole;
      // Optionally, update user data based on role if needed
    },
  },
});

// Action creators are generated for each case reducer function
export const { setRole, setUser, setToken, setAuth, clearAuth, clearRole, logout, switchToRole } =
  roleSlice.actions;

export default roleSlice.reducer;
